import React from "react";
import { motion } from "framer-motion";
import { GALLERY } from "@/data/content";
import { Reveal, MaskedLinesInView } from "./Motion";

const GalleryImage = ({ img, index }) => (
  <motion.figure
    data-testid={`gallery-image-${index}`}
    initial={{ opacity: 0, y: 40 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-40px" }}
    transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1], delay: (index % 3) * 0.08 }}
    className="group relative mb-5 md:mb-6 break-inside-avoid overflow-hidden rounded-2xl border border-white/[0.06]"
  >
    <img
      src={img.src}
      alt={img.alt}
      loading="lazy"
      className="w-full h-auto object-cover transition-transform duration-700 ease-out group-hover:scale-[1.05]"
    />
    <div className="pointer-events-none absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500" />
    <figcaption className="pointer-events-none absolute bottom-4 left-4 right-4 translate-y-3 opacity-0 group-hover:translate-y-0 group-hover:opacity-100 transition-all duration-500">
      <span className="text-xs tracking-[0.2em] uppercase text-gold-light">{img.alt}</span>
    </figcaption>
  </motion.figure>
);

const Gallery = () => {
  return (
    <section id="gallery" data-testid="gallery-section" className="relative py-24 md:py-32 lg:py-40">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-14 md:mb-20">
          <div>
            <Reveal>
              <p className="text-xs tracking-[0.3em] uppercase text-gold mb-6">{GALLERY.overline}</p>
            </Reveal>
            <h2 className="font-serif tracking-tight leading-[1.05] text-4xl sm:text-5xl lg:text-6xl">
              <MaskedLinesInView lines={[GALLERY.heading]} className="text-white" />
              <MaskedLinesInView lines={[GALLERY.headingAccent]} lineClassName="italic text-gold-gradient" delay={0.1} />
            </h2>
          </div>
          <Reveal delay={0.15}>
            <p className="max-w-xs text-sm text-white/55 leading-relaxed md:text-right">
              A glimpse into the frames couples call their most treasured possession.
            </p>
          </Reveal>
        </div>

        {/* Pinterest-style masonry */}
        <div className="columns-1 sm:columns-2 lg:columns-3 gap-5 md:gap-6">
          {GALLERY.images.map((img, i) => (
            <GalleryImage key={i} img={img} index={i} />
          ))}
        </div>
      </div>
    </section>
  );
};

export default Gallery;
